import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CoreModule } from "@obg/ngx.core";

import { CommonValidationErrorModule } from "../validation-error/common-validation-error.module";

import { CommonValidationRendererComponent } from "./common-validation-renderer.component";

const DIRECTIVES = [CommonValidationRendererComponent];

@NgModule({
	imports: [CommonModule, CommonValidationErrorModule, CoreModule, TranslateModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CommonValidationRendererModule {}
